
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StatusItemProps } from ".";
import { loading, update } from "store/status";
import { AppMessage } from "components";

interface ApiStatusUpdateInputProps extends StatusItemProps {
}

type ApiStatusUpdateOutputProps = OutputBaseProps<{ item: StatusItemProps; }, ApiStatusUpdateInputProps>

export const apiStatusUpdate = async (data: ApiStatusUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiStatusUpdateOutputProps>("/api/status/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};